import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import refreshLatestStatusIcon from "../../assets/icon-refresh.svg";
import { assessmentCenterRefreshIconButtonSx } from "./assessmentCenterFilterBarSx";

export type AssessmentCenterRefreshLatestStatusButtonProps = Readonly<{
  onRefresh?: () => void;
}>;

export default function AssessmentCenterRefreshLatestStatusButton({
  onRefresh,
}: AssessmentCenterRefreshLatestStatusButtonProps) {
  return (
    <Tooltip title="Get the latest status">
      <span>
        <IconButton
          aria-label="Get the latest status"
          onClick={() => onRefresh?.()}
          disabled={!onRefresh}
          sx={assessmentCenterRefreshIconButtonSx}
        >
          <Box
            component="img"
            src={refreshLatestStatusIcon}
            alt=""
            sx={{ width: 17, height: 17, display: "block", objectFit: "contain" }}
          />
        </IconButton>
      </span>
    </Tooltip>
  );
}
